"use strict";

exports.__esModule = true;
exports.UserName = UserName;
exports.getUserName = getUserName;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
 * Displays a user's name.
 */
function UserName(_ref) {
  var user = _ref.user;
  var name = getUserName(user);
  return /*#__PURE__*/_react["default"].createElement("span", null, name);
}
function getUserName(user) {
  var name = user.username;
  if (user.profile != null && user.profile.name != null) {
    var _user$profile$name = user.profile.name,
      first = _user$profile$name.first,
      last = _user$profile$name.last;
    name = first + " " + last;
  }
  return name;
}